import { Text } from '@cash-me/react-components'

export const myths = [
  {
    id: 'myths-1',
    title: '"Home Equity é complicado"',
    description: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Usar o limite do cartão de crédito é tão simples que muitas vezes você nem percebe que está usando. Em troca,
          você paga juros maiores para usar esse recurso. O home equity exige sim alguns procedimentos para a liberação
          dos recursos, mas a CashMe faz a maior parte do trabalho.
        </Text>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Você não precisa nem sair de casa para solicitar esta modalidade com a gente. Basta providenciar os documentos
          exigidos e esperar alguns dias até que o dinheiro esteja na sua conta.
        </Text>
      </>
    )
  },
  {
    id: 'myths-2',
    title: '"Só posso fazer Home Equity se não tiver outras dívidas"',
    description: (
      <Text size="body2" color="var(--colors-neutral-text-weak)">
        Uma das características do home equity é não vincular o empréstimo ao uso dos recursos. Ou seja, você pode usar
        o dinheiro para o que quiser, inclusive para quitar dívidas mais caras, o que nós recomendamos que você faça.
      </Text>
    )
  },
  {
    id: 'myths-3',
    title: '"O risco de perder o meu imóvel é muito alto"',
    description: (
      <Text size="body2" color="var(--colors-neutral-text-weak)">
        O risco existe caso você não honre com suas dívidas. No entanto, o interesse de quem concede empréstimo é
        receber de volta o dinheiro emprestado acrescido de juros. Esse é o negócio da CashMe. Por isso, vamos fazer de
        tudo para te ajudar a quitar sua dívida sem comprometer os seus bens. Isso inclui uma análise aprofundada da sua
        capacidade como pagador. O que mais queremos é que você realize seus sonhos e conte com a CashMe sempre que
        precisar de um recurso extra!
      </Text>
    )
  }
]
